import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { Container, Button, Box, TextField, Alert,useMediaQuery } from '@mui/material';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from "../../App";
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Autocomplete from '@mui/material/Autocomplete';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { styled } from '@mui/material/styles';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { TableContainer, Paper, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { Row, Col, Card } from 'antd';
import { format } from 'date-fns'; // Import date-fns for formatting
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Backdrop, CircularProgress, } from '@mui/material';
import { Warning } from '@material-ui/icons';
import Radio from '@mui/material/Radio';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


import { useLocation } from 'react-router-dom';

// Extend dayjs with customParseFormat to support custom formats
dayjs.extend(customParseFormat);
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  // Add some color and border radius to the modal content
  //border: '2px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  p: 4,
  datePickerInput: {
    width: '150px',
    height: '40px',
    padding: '8px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },

};
const StyledTextField = styled(TextField)({
  width: '100%', // Set to 100% for better responsiveness
  maxWidth: '250px', // Max width to limit excessive stretching on larger screens
  '& .MuiInputBase-root': {
    height: '50px', // Adjust height as needed
    fontSize: '16px',
  },
  '& .MuiInputLabel-root': {
    fontSize: '16px', // Adjust label font size
  },
});

/* Custom styles for react-datepicker */
const customDatePickerStyles = `
.react-datepicker__header {
  background-color: #0080FF;
  border: none;
  color: #fff;
}

.react-datepicker__current-month {
  font-size: 18px; /* Adjust month font size for better readability */
}

.react-datepicker__month-dropdown,
.react-datepicker__year-dropdown {
  width: 100%; /* Use full width */
  max-width: 300px; /* Max width for dropdowns */
  height: auto; /* Automatic height adjustment */
  overflow-y: auto; /* Add scrollbar if content overflows */
}

.react-datepicker__month-dropdown .react-datepicker__month-option,
.react-datepicker__year-dropdown .react-datepicker__year-option {
  height: auto; /* Automatic height adjustment */
  line-height: normal; /* Default line height */
}

.react-datepicker__day {
  height: 40px; /* Adjust date cell height */
  line-height: 40px; /* Adjust line-height for center alignment */
}

/* Media query for smaller screens */
@media (max-width: 600px) {
  .react-datepicker__month-dropdown,
  .react-datepicker__year-dropdown {
    max-width: 100%; /* Full width on smaller screens */
  }

  .react-datepicker__day {
    height: 35px; /* Smaller date cell height for small screens */
    line-height: 35px; /* Adjust line-height */
  }
}
`;

// Inject custom styles into the document head
const injectCustomStyles = () => {
  const styleTag = document.createElement('style');
  styleTag.innerHTML = customDatePickerStyles;
  document.head.appendChild(styleTag);
};
const Defectivegoodsreceipts = () => {
  const [open2, setOpen2] = React.useState(false);
  const [progress, setProgress] = useState(0); // State to manage progress percentage
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  //const handleOpen = () => setOpen(true);
  //const handleOpen1 = () => setOpen1(true);
  //const handleClose = () => setOpen(false);
  const handleClose1 = () => setOpen1(false);
  const [data, setData] = useState([]);
  const [inputMobileNumber, setInputMobileNumber] = useState('');
  const [showTable, setShowTable] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [dealerOptions, setDealerOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [regionname, setregionname] = useState('');
  const [selectarea, setselectarea] = useState('');
  const [Districtname, setDistrictname] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [result, setResult] = useState([]);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [receivedFromName, setReceivedFromName] = useState('');
  // const [receivedFromDate, setReceivedFromDate] = useState(dayjs());
  // const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(dayjs());
  const [comments, setComments] = useState('');
  const [motor, setMotor] = useState(0);
  const [pump, setPump] = useState(0);
  const [panel, setPanel] = useState(0);
  const [cable, setCable] = useState(0);
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [pincode, setPincode] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [areas, setAreas] = useState([]);
  const [regionCode, setRegionCode] = useState('');
  const [regionName, setRegionName] = useState('');
  const [districtCode, setDistrictCode] = useState('');
  const [districtName, setDistrictName] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [labourDetails, setLabourDetails] = useState([]);
  const [spareDetails, setSpareDetails] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [receivedFromDate, setReceivedFromDate] = useState(null);
  const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(null);
  const [loginId, setLoginId] = useState(null);

const [generating, setGenerating] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
 const isMobile = useMediaQuery('(max-width:768px)');

  const today = new Date();

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleReceivedFromDateChange = (date) => setReceivedFromDate(date);
  const handleExpectedDeliveryDateChange = (date) => setExpectedDeliveryDate(date);

  useEffect(() => {

    if (!queryParams.get('LOGIN_ID')) {

      const login_id = localStorage.getItem("LOGIN_ID");
      fetchDealerData(login_id);
      setLoginId(login_id);

    } else {
      const login_id1 = queryParams.get('LOGIN_ID');

      axios.post(BASE_URL + "/getloginidEncode", { login_id: login_id1 })
        .then((response) => {
          const login_id = response.data.login_id;
          fetchDealerData(login_id);
          setLoginId(login_id);
        })
        .catch((error) => {
          Swal.fire('Error', 'LOGIN_ID NOT DECRIPTED', 'error');
        });
    }
  }, [BASE_URL, setOpen]);

  // const [selectedRowData, setSelectedRowData] = useState(null);
  //const login_id = localStorage.getItem("LOGIN_ID");


  const fetchData = async () => {
    setOpen2(true);  // Show loading indicator

    try {
      const response = await axios.post(BASE_URL + '/serviceClaimmobil', {
        mobileno: inputMobileNumber
      });

      const data = response.data;
      const serviceClaims = data.service_claims;

      if (serviceClaims && serviceClaims.length > 0) {
        setData(serviceClaims);
        setShowTable(true);
      } else {
        setData([]);
        setShowTable(false);
        setOpen2(false);  // Hide loading indicator before showing alert
        await Swal.fire({
          title: 'No Data',
          text: data.message,
          icon: 'info',
          confirmButtonText: 'OK'
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpen2(false);  // Hide loading indicator before showing alert
      const errorMessage = error.response?.data?.message || 'Error while fetching data.';

      await Swal.fire({
        title: 'No Data',
        text: errorMessage,
        icon: 'info',
        confirmButtonText: 'OK'
      });

      setData([]);
      setShowTable(false);
    } finally {
      setOpen2(false);  // Ensure loading indicator is hidden in all cases
    }
  };
  const handleClose = () => {
    // Reset all state variables to their initial values
    setName('');
    setAddress('');

    setDistricts(null);  // or '' depending on your initial state value
    setAreas(null);  // or '' depending on your initial state value
    setPincode('');  // or '' depending on your initial state value
    setPhoneNumber('');
    setOpen(false);
  };
  const handleOpen = () => {
    setPhoneNumber(inputMobileNumber);  // Set phoneNumber to the value of inputMobileNumber
    setOpen(true);
  };
  const formatDate = (date) => {
    return date ? format(date, 'dd/MM/yyyy') : '';
    if (!(date instanceof Date)) throw new Error('Invalid Date object');
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  const handleOpen1 = async (row) => {
    try {
      // Show loading indicator or disable button
      setOpen2(true);
      const formattedComplaintReceivedDate = formatDate(row.ComplaintReceivedDate);
      // Make the API call
      const response = await axios.post(`${BASE_URL}/getlabourandsparedetails`, {
        serial_no: serialNumber,
        ComplaintReceivedDate: formattedComplaintReceivedDate,
        Branch: row.ASCCode,
        ItemCode: row.ItemCode,
        ASCCode: row.ASCCode,
        ServiceType_FreePaid: row.ServiceType_FreePaid,
      });

      // Handle the API response here
      console.log('API response:', response.data);

      // Update state with the fetched data
      setLabourDetails(response.data.data.LabourDetails);
      setSpareDetails(response.data.data.SpareDetails);

      // Open the dialog
      setOpen1(true);
    } catch (error) {
      console.error('Error fetching data:', error);

      setError('Failed to fetch labour and spare details. Please try again.');
    } finally {

      setOpen2(false);
    }
  };


  const fetchDealerData = async (login_id) => {
    try {
      const response = await axios.post(`${BASE_URL}/getdealercodeWogst`, { login_id });
      const data = response.data?.DEALER_CODE || [];
      const formattedData = data.map(dealer => ({
        name: dealer.DEALER_DESC || dealer.DEALERNAME,
        code: dealer.DEALER_CODE
      }));

      setDealerOptions(formattedData);

      // Set the default selected dealer to the first option if it exists
      if (formattedData.length > 0) {
        setSelectedDealer(formattedData[0]);
      }
    } catch (error) {
      console.error('Error fetching dealer data:', error);
      setOpen(false);
    }
  };


  // useEffect(() => {
  // // Function to fetch dealer data from the API


  // // Call the fetch function
  // fetchDealerData();
  // }, [login_id, BASE_URL, setOpen]);

  const handleDealerChange = (event, value) => {
    setSelectedDealer(value);
  };



  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/State`);
        setStates(response.data.State);
      } catch (error) {
        console.error('Error fetching states:', error);
      }
    };
    fetchStates();
  }, [BASE_URL]);

  const fetchDistricts = async (selectedRegionCode) => {
    try {
      if (!selectedRegionCode) return;
      const response = await axios.post(`${BASE_URL}/getDistrictsByRegion?region_code=${selectedRegionCode}`);
      setDistricts(response.data.districts);
    } catch (error) {
      console.error('Error fetching districts:', error);
    }
  };

  const fetchAreas = async (selectedRegionCode, selectedDistrictCode) => {
    try {
      if (!selectedRegionCode || !selectedDistrictCode) return;
      const response = await axios.post(`${BASE_URL}/getAreasByDistrictAndRegion?region_code=${selectedRegionCode}&district_code=${selectedDistrictCode}`);
      setAreas(response.data.areas);
    } catch (error) {
      console.error('Error fetching areas:', error);
    }
  };

  const fetchPincode = async (areaCode) => {
    try {
      if (!areaCode) return;
      const response = await axios.post(`${BASE_URL}/getpincode?area_code=${areaCode}`);
      setPincode(response.data.pincode[0]?.pincode); // Assuming response.data is the pincode array
    } catch (error) {
      console.error('Error fetching pincode:', error);
    }
  };

  const handleRegionChange = (event, newValue) => {
    if (newValue) {
      setRegionCode(newValue.region_code);
      setRegionName(newValue.STATE);
      fetchDistricts(newValue.region_code);
      setDistricts([]); // Clear districts when region changes
      setAreas([]); // Clear areas when region changes
      setPincode(''); // Clear pincode when region changes
    }
  };

  const handleDistrictChange = (event, newValue) => {
    if (newValue) {
      setDistrictCode(newValue.district_code);
      setDistrictName(newValue.district_desc);
      fetchAreas(regionCode, newValue.district_code);
      setAreas([]); // Clear areas when district changes
      setPincode(''); // Clear pincode when district changes
    }
  };

  const handleAreaChange = (event, newValue) => {
    if (newValue) {
      fetchPincode(newValue.area_code);
      setSelectedArea(newValue.area_name);
    }
  };
  const handleSaveButtonClick = () => {
    const data = {
      name,
      address,
      pincode,
      mobileno: phoneNumber,
      state: regionName,
      district: districtName,
      place: selectedArea,
      login_id: loginId,
    };

    axios
      .post(`${BASE_URL}/getnewmobilnocreate`, data)
      .then((response) => {
        // Check if the status code is 200
        if (response.status === 200) {
          handleClose();

          // Extract the message from the response
          const message = response.data.message || "Data saved successfully.";

          Swal.fire({
            title: "Success!",
            text: message,
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            console.log("Success alert closed");
          });

          console.log("Data saved successfully:", response.data);
        } else {
          // If the status code is not 200, handle it as an error
          throw new Error("Unexpected status code: " + response.status);
        }
      })
      .catch((error) => {
        handleClose();

        // Set open to false on error
        if (typeof setOpen === "function") {
          setOpen(false);
        }

        // Handle specific error based on status code
        let errorMessage;
        if (error.response && error.response.status === 400) {
          errorMessage = error.response.data.text || "Bad Request: There was an issue with your submission.";
        } else {
          errorMessage = error.response?.data?.message || "Error while saving data.";
        }

        Swal.fire({
          title: "Error!",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          // Set open to true after the error alert is closed
          if (typeof setOpen === "function") {
            setOpen(true);
          }
        });

        console.error("Error while saving data:", {
          message: errorMessage,
          details: error.response?.data || error.message,
          stack: error.stack,
        });
      });
  };

  const handleSearch = () => {
    setOpen2(true); // Show backdrop when search starts
    let errorMessage = ''; // Initialize errorMessage

    axios
      .post(`${BASE_URL}/getserialnumberdetailspro?serial_no=${serialNumber}`)
      .then((response) => {
        setResult([response.data.data]);
      })
      .catch((error) => {
        console.error('Error:', error);
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else {
          errorMessage = 'Something went wrong. Please try again later.';
        }
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: errorMessage,
        });
      })
      .finally(() => {
        setOpen2(false); // Hide backdrop when request completes (whether success or error)
      });
  };
  const handleCheckboxChange = (setState) => (e) => {
    setState(e.target.checked ? 1 : 0);
  };

  // const handleGenerateToken = () => {
  //   if (selectedValue === null) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: 'Please select a Customer Adderss before generating a token.',
  //     });
  //     return;
  //   }

  //   const selectedRow = data[selectedValue]; // Retrieve the selected row data

  //   if (!inputMobileNumber) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: 'Kindly enter mobile number',
  //     });
  //     return;
  //   }

  //   if (!serialNumber) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: 'Kindly enter serial number',
  //     });
  //     return;
  //   }

  //   if (!(motor || pump || panel || cable)) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: 'Please select received items (Motor, Pump, Panel, Cable)',
  //     });
  //     return;
  //   }

  //   const formData = {
  //     serial_no: result[0]?.serialno || '',
  //     ITEMCODE: result[0]?.MATCODE || '',
  //     BRANCH_CODE: result[0]?.BRANCHCODE || '',
  //     GENERATEDBY: loginId,
  //     RECBYNAME: receivedFromName,
  //     RECBYDATE: receivedFromDate ? dayjs(receivedFromDate).format('DD-MMM-YYYY') : '',
  //     EXPDATE: expectedDeliveryDate ? dayjs(expectedDeliveryDate).format('DD-MMM-YYYY') : '',
  //     TOKEN_COMMENTS: comments,
  //     Motor: motor,
  //     Pump: pump,
  //     Panel: panel,
  //     Cable: cable,
  //     ASSIGNEDTO: selectedDealer ? selectedDealer.code : '',
  //     ASSNAME: selectedDealer ? selectedDealer.name : '',
  //     Name: selectedRow.name,         // Selected row data
  //     address: selectedRow.address,   // Selected row data
  //     place: selectedRow.place,       // Selected row data
  //     district: selectedRow.district, // Selected row data
  //     State: selectedRow.state,       // Selected row data
  //     Pincode: selectedRow.pincode,   // Selected row data
  //     MOBILENO: selectedRow.mobileno, // Selected row data
  //   };

  //   axios.post(`${BASE_URL}/createServiceToken`, formData)
  //     .then((response) => {
  //       setOpen2(false);
  //       const responseMessage = response.data.message || 'Data saved successfully!';
  //       const tokenNumber = response.data.message2 || '';

  //       Swal.fire({
  //         title: 'Success',
  //         text: `${responseMessage} ${tokenNumber}`,
  //         icon: 'success',
  //         confirmButtonText: 'OK'
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           window.location.reload();
  //         }
  //       });
  //     }).catch(error => {
  //       setOpen2(false);
  //       const errorMessage = error.response?.data?.message || 'There was an error saving the data.';
  //       console.error('Error while saving data:', error);
  //       Swal.fire({
  //         title: 'Warning',
  //         text: errorMessage,
  //         icon: 'warning',
  //         confirmButtonText: 'OK'
  //       });
  //     });
  // };
const handleGenerateToken = () => {

  // 🔒 Prevent double request
  if (generating) return;

  // -------------------------
  // VALIDATIONS
  // -------------------------
  if (selectedValue === null) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Please select a Customer Address before generating a token.",
    });
    return;
  }

  if (!inputMobileNumber) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Kindly enter mobile number",
    });
    return;
  }

  if (!serialNumber) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Kindly enter serial number",
    });
    return;
  }

  if (!(motor || pump || panel || cable)) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Please select received items (Motor, Pump, Panel, Cable)",
    });
    return;
  }

  // 🔒 LOCK after all validations passed
  setGenerating(true);

  const selectedRow = data[selectedValue];

  const formData = {
    serial_no: result[0]?.serialno || "",
    ITEMCODE: result[0]?.MATCODE || "",
    BRANCH_CODE: result[0]?.BRANCHCODE || "",
    GENERATEDBY: loginId,

    RECBYNAME: receivedFromName,
    RECBYDATE: receivedFromDate
      ? dayjs(receivedFromDate).format("DD-MMM-YYYY")
      : "",
    EXPDATE: expectedDeliveryDate
      ? dayjs(expectedDeliveryDate).format("DD-MMM-YYYY")
      : "",

    TOKEN_COMMENTS: comments,

    Motor: motor,
    Pump: pump,
    Panel: panel,
    Cable: cable,

    ASSIGNEDTO: selectedDealer ? selectedDealer.code : "",
    ASSNAME: selectedDealer ? selectedDealer.name : "",

    // Customer details
    Name: selectedRow.name,
    address: selectedRow.address,
    place: selectedRow.place,
    district: selectedRow.district,
    State: selectedRow.state,
    Pincode: selectedRow.pincode,
    MOBILENO: selectedRow.mobileno,
  };

  // -------------------------
  // API CALL
  // -------------------------
  axios
    .post(`${BASE_URL}/createServiceToken`, formData)
    .then((response) => {
      setOpen2(false);

      const responseMessage =
        response.data.message || "Data saved successfully!";
      const tokenNumber = response.data.message2 || "";

      Swal.fire({
        title: "Success",
        text: `${responseMessage} ${tokenNumber}`,
        icon: "success",
        confirmButtonText: "OK",
      }).then((res) => {
        if (res.isConfirmed) {
          window.location.reload(); // 🔁 reset state
        }
      });
    })
    .catch((error) => {
      // 🔓 Unlock only on failure
      setGenerating(false);
      setOpen2(false);

      const errorMessage =
        error.response?.data?.message ||
        "There was an error saving the data.";

      console.error("Error while saving data:", error);

      Swal.fire({
        title: "Warning",
        text: errorMessage,
        icon: "warning",
        confirmButtonText: "OK",
      });
    });
};



  return (
    <Container>
      <br></br>
      <Card className="shadow bg-white rounded">
        <center>
          <h5 style={{ fontWeight: '1000' }}><i>
            Service Call Details</i></h5>
        </center>
        <br></br>
        <Row
          component="form"
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& > :not(style)': { marginRight: '10px' },
          }}
          noValidate
          autoComplete="off"
          gutter={[16, 10]}
        >
<Col span={24} md={8} sm={24} xs={24} lg={8} xl={8} xxl={8}>
          <TextField
            id="outlined-basic"
            label="Customer Mobile Number"
            style={{ width: '100%' }}
            variant="outlined"
            value={inputMobileNumber}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                setInputMobileNumber(value);
              }
            }}
            inputProps={{ maxLength: 15 }} // Optional: Set a max length for the input
          />
          </Col>
          <Col span={24} md={8} sm={24} xs={24} lg={8} xl={8} xxl={8} style={{ textAlign: 'left', marginTop: '7px' }}>
          <Button variant="contained" size="small" style={{ background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)', color: 'black', marginLeft: '10px' }} onClick={fetchData} > Search</Button>
          <Button onClick={handleOpen} size="small" style={{ background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)', color: 'black', marginLeft: '10px'  }} variant="contained">New Service Call</Button>
          </Col>
        </Row></Card>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"


      >
        <Box sx={{ ...style, '& > :not(style) + :not(style)': { mt: 2 } }}>
          {/* First Row */}
          <center>
            <h5 style={{ fontWeight: '1000' }}><i>
              Customer Creation</i></h5>
          </center>
          <br></br>
          <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
            <TextField id="outlined-basic" sx={{ width: 300 }} label="Name" variant="outlined" onChange={(e) => setName(e.target.value)} inputProps={{ maxLength: 40 }} />
            <TextField id="outlined-basic" sx={{ width: 300 }} label="Address" variant="outlined" onChange={(e) => setAddress(e.target.value)} inputProps={{ maxLength: 40 }} />            </Stack>
          <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
            {/* <TextField id="outlined-basic" sx={{ width: 300 }} label="Pincode" variant="outlined" /> */}

            {/* Second Row */}
            <Autocomplete
              disablePortal
              id="state-autocomplete"
              sx={{ width: 400 }}
              options={states}
              getOptionLabel={(option) => option.STATE}
              renderInput={(params) => <TextField {...params} label="STATE" />}
              onChange={handleRegionChange}
            />
          </Stack>
          <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
            <Autocomplete
              disablePortal
              id="district-autocomplete"
              sx={{ width: 400 }}
              options={districts}
              getOptionLabel={(option) => option.district_desc}
              renderInput={(params) => <TextField {...params} label="DISTRICT" />}
              onChange={handleDistrictChange}
            />

            <Autocomplete
              disablePortal
              id="area-autocomplete"
              sx={{ width: 400 }}
              options={areas}
              getOptionLabel={(option) => option.area_name}
              renderInput={(params) => <TextField {...params} label="AREA" />}
              onChange={handleAreaChange}
            />

          </Stack>

          {/* Third Row */}
          <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
            <TextField
              id="pincode"
              sx={{ width: 400 }}
              label="PINCODE"
              value={pincode}
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              id="outlined-basic"
              label="Phone Number"
              variant="outlined"
              sx={{ width: 400 }}
              value={phoneNumber}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setPhoneNumber(value);
                }
              }}
              inputProps={{ maxLength: 10 }}
            />
          </Stack>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div style={{ justifyContent: 'center' }}>
              <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                <Button
                  variant="outlined"
                  sx={{
                    flexGrow: 1,
                    height: '40px',  // height as a string
                    width: '200px',  // width as a string
                    borderRadius: '8px'  // borderRadius as a string
                  }}
                  size="medium"
                  onClick={() => {
                    handleSaveButtonClick();
                    fetchData();
                  }}
                >
                  Save
                </Button>
                <Button
                  variant="outlined"
                  size="medium"
                  height={40}
                  width="200px"
                  borderRadius="8px"
                  type="submit"
                  sx={{ flexGrow: 1 }}
                  color="error"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </Stack>
              <br />
            </div>
          </Typography>
        </Box>
      </Modal>
      <br></br>
      {showTable && data.length > 0 && (
        <TableContainer
          component={Paper}
          style={{
            marginTop: '20px',
            maxHeight: '350px',  // Set a max height for the table container
            overflowY: 'auto'    // Enable vertical scrolling
          }}
        >
          <Table
            style={{
              borderCollapse: 'separate',
              borderSpacing: '4px',
              width: '100%',
              textAlign: 'center',
              fontSize: '15px'
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', position: 'sticky', top: '0', zIndex: '1' }}>Select</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', position: 'sticky', top: '0', zIndex: '1' }}>S.No</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', position: 'sticky', top: '0', zIndex: '1' }}>Name</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', position: 'sticky', top: '0', zIndex: '1' }}>Address</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', position: 'sticky', top: '0', zIndex: '1' }}>Place</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', position: 'sticky', top: '0', zIndex: '1' }}>District</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', position: 'sticky', top: '0', zIndex: '1' }}>State</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', position: 'sticky', top: '0', zIndex: '1' }}>Pincode</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', position: 'sticky', top: '0', zIndex: '1' }}>Mobile No</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                    <Radio
                      color="primary"
                      value={index}
                      checked={selectedValue === index.toString()}
                      onChange={handleRadioChange}
                      inputProps={{ 'aria-label': `select row ${index + 1}` }}
                    />
                  </TableCell>
                  <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textTransform: 'uppercase' }}>
                    {index + 1}
                  </TableCell>
                  <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textTransform: 'uppercase' }}>
                    {row.name}
                  </TableCell>
                  <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textTransform: 'uppercase' }}>
                    {row.address}
                  </TableCell>
                  <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textTransform: 'uppercase' }}>
                    {row.place}
                  </TableCell>
                  <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textTransform: 'uppercase' }}>
                    {row.district}
                  </TableCell>
                  <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textTransform: 'uppercase' }}>
                    {row.state}
                  </TableCell>
                  <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textTransform: 'uppercase' }}>
                    {row.pincode}
                  </TableCell>
                  <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textTransform: 'uppercase' }}>
                    {row.mobileno}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <br></br>
      {showTable && data.length === 0 && ( // Conditionally render a message when showTable is true but data is empty
        <div></div>
      )}


      <Card className="shadow bg-white rounded">
        <center>
          <h5 style={{ fontWeight: '1000' }}><i>
            Serial Number Details</i></h5>
        </center>       <br></br>
        <Row
          component="form"
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& > :not(style)': { marginRight: '10px' },
          }}
          noValidate
          autoComplete="off"
          gutter={[16, 10]}
        >
          <Col span={24} md={8} sm={24} xs={24} lg={8} xl={8} xxl={8}>
          <TextField
            id="outlined-basic"
            label="Serial Number"
            style={{ width: '100%' }}
            variant="outlined"
            value={serialNumber}
            onChange={e => setSerialNumber(e.target.value)}
          />
          </Col>
          <Col span={24} md={8} sm={24} xs={24} lg={8} xl={8} xxl={8} style={{ textAlign: 'left', marginTop: '7px' }}>
          <Button
            variant="contained"
            style={{ background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)', color: 'black' }}
            onClick={handleSearch}
          >
            Search
          </Button>
          </Col>
          <Col span={24} md={8} sm={24} xs={24} lg={8} xl={8} xxl={8}>
          <Stack spacing={2} sx={{ width: '100%' }}>
            {/* Autocomplete for Dealer */}
            <Autocomplete
              id="dealer-autocomplete"
              freeSolo
              options={dealerOptions}
              value={selectedDealer}
              onChange={handleDealerChange}
              getOptionLabel={(option) => `${option.name} - ${option.code}`}
              renderInput={(params) => <TextField {...params} label="Assigned To" />}
            />
          </Stack>
          </Col>
        </Row></Card>
      <br></br>
      {result.length > 0 && (
        <>
          <Card className="shadow rounded" style={{ width: '100%', height: '60px', fontWeight: 'bold', textDecoration: 'underline', background: '#61d1e5', color: 'black' }}>
            <h5><p>Serial Details</p></h5>
          </Card>

          <TableContainer component={Paper}>
            <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>S.No</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Serial No</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Item Code</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Item Description</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Branch</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Dealer Code</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Dealer Name</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >D.O.P</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >PSG</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Warranty Upto</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Service Type</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {result.map((row, index) => (
                  <TableRow key={index} sx={style.tableRow}>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{index + 1}</TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.serialno}</TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.MATCODE}</TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.ITEMDESCRIPTION}</TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.BRANCHNAME}</TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.DEALERCODE}</TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.DEALERNAME}</TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.DATEOFPURCHASE}</TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.ITEMPRODUCTSUBGROUP}</TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.D2}</TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.D1}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
      {result.length > 0 && (
        <Card className="shadow rounded" style={{ width: '100%', height: '60px', fontWeight: 'bold', textDecoration: 'underline', background: '#61d1e5', color: 'black' }}>
          <h5><p>Service Claim History</p></h5>
        </Card>
      )}
      {result.length > 0 && (
        <TableContainer component={Paper}>
          <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>S.No</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Complaint Received Date</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Item Code</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Item Description</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Branch</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>ASC Code</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>ASC Name</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>PSG</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>ASC Warranty</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Service Type </TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {result.map((item, itemIndex) => (
                item.SerivceClaimHistory.map((row, rowIndex) => {
                  // Check if any field is empty
                  const isAnyFieldEmpty = [
                    row.ComplaintReceivedDate,
                    row.ItemCode,
                    row.ItemDes,
                    row.Branch,
                    row.ASCCode,
                    row.ASCName,
                    row.PSGDes,
                    row.ASCWarranty,
                    row.ServiceType_FreePaid,
                  ].some(field => !field || field.trim() === '');

                  // Render the row or "No Data Found" message
                  if (isAnyFieldEmpty) {
                    return (
                      <TableRow key={`${itemIndex}-${rowIndex}`}>
                        <TableCell colSpan={11} style={{ padding: '10px', background: '#e3fafe', color: 'black', textAlign: 'center' }}>
                          No Data Found
                        </TableCell>
                      </TableRow>
                    );
                  }

                  return (
                    <TableRow key={`${itemIndex}-${rowIndex}`}>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {(itemIndex * item.SerivceClaimHistory.length) + rowIndex + 1}
                      </TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {row.ComplaintReceivedDate}
                      </TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {row.ItemCode}
                      </TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {row.ItemDes}
                      </TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {row.Branch}
                      </TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {row.ASCCode}
                      </TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {row.ASCName}
                      </TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {row.PSGDes}
                      </TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {row.ASCWarranty}
                      </TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {row.ServiceType_FreePaid}
                      </TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        <Button onClick={() => handleOpen1(row)} color="primary">
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Modal
        open={open1}
        onClose={handleClose1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          ...style,
          '& > :not(style) + :not(style)': { mt: 2 },
          maxHeight: '80vh', // Set max height
          overflowY: 'auto', // Enable vertical overflow scrolling
        }}>

          <TableContainer component={Paper}>
            <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>S.No</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>LabourID</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Labour Charge Description</TableCell>
                </TableRow>
              </TableHead>
              {/* <TableBody>
      {labourDetails.map((row, index) => (
        <TableRow key={index}>
          <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{index + 1}</TableCell>
          <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.LabourID}</TableCell>
          <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.LabourChargeDescription}</TableCell>
        </TableRow>
      ))}
    </TableBody> */}

              <TableBody>
                {labourDetails.length === 0 || labourDetails.every(row =>
                  !row.LabourID &&
                  !row.LabourChargeDescription

                ) ? (
                  <TableRow>
                    <TableCell colSpan={4} style={{ padding: '10px', textAlign: 'center', background: '#e3fafe', color: 'black' }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                ) : (
                  labourDetails.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{index + 1}</TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.LabourID}</TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.LabourChargeDescription}</TableCell>

                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <br></br>    <br></br>

          <TableContainer component={Paper}>
            <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }} >
              <TableHead>
                <TableRow>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>S.No</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Spare Code</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Spare Name</TableCell>
                  <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {spareDetails.length === 0 || spareDetails.every(row =>
                  !row.SpareCode &&
                  !row.SpareName &&
                  !row.Quantity
                ) ? (
                  <TableRow>
                    <TableCell colSpan={4} style={{ padding: '10px', textAlign: 'center', background: '#e3fafe', color: 'black' }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                ) : (
                  spareDetails.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{index + 1}</TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.SpareCode}</TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.SpareName}</TableCell>
                      <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.Quantity}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <center>
            <Button
              variant="outlined"
              size="medium"
              height={40}
              width="300px"
              borderRadius="8px"
              type="submit"
              sx={{ flexGrow: 1 }}

              onClick={handleClose1}
            >
              Close
            </Button></center>
        </Box>


      </Modal>
      {result.length > 0 && (
        <Card className="shadow rounded" style={{ width: '100%', height: '60px', fontWeight: 'bold', textDecoration: 'underline', background: '#61d1e5', color: 'black' }}>
          <h5><p>Customer Details</p></h5>
        </Card>
      )}

      {result.length > 0 && (
        <TableContainer component={Paper}>
          <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>S.No</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Customer Name</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}  >Address</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}  >Place</TableCell>

                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Country</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }} >Region/State</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}  >Pin Code</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}  >Mobile</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}  >Invoice Date</TableCell>
                <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Warranty status</TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {result.length === 0 || result.every(row =>
                !row.CUSTOMERNAME &&
                !row.ADDRESS &&
                !row.PLACE &&
                !row.COUNTRY &&
                !row.REGION &&
                !row.PINCODE &&
                !row.MOBILENO &&
                !row.INVOICEDATE &&
                !row.Warrantystatus
              ) ? (
                <TableRow>
                  <TableCell colSpan={10} style={{ padding: '10px', textAlign: 'center', background: '#e3fafe', color: 'black' }}>
                    No Data Found
                  </TableCell>
                </TableRow>
              ) : (
                result.map((row, index) => (
                  <TableRow key={index} sx={style.tableRow}>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {index + 1}
                    </TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {row.CUSTOMERNAME}
                    </TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {row.ADDRESS}
                    </TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {row.PLACE}
                    </TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {row.COUNTRY}
                    </TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {row.REGION}
                    </TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {row.PINCODE}
                    </TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {row.MOBILENO}
                    </TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {row.INVOICEDATE}
                    </TableCell>
                    <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {row.Warrantystatus}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <br></br>
      <Card className="shadow bg-white rounded">
        <center>
          <h5 style={{ fontWeight: '1000' }}><i>
            Generate Token Number </i></h5>
        </center>       <br></br>
        <Row
          component="form"
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& > :not(style)': { marginRight: '10px' },
          }}
          noValidate
          autoComplete="off"
          gutter={[16, 10]}
        >
          <Col span={24} md={8} sm={24} xs={24} lg={8} xl={8} xxl={8}>
          <TextField id="outlined-basic" label="Received From Name" style={{ width: '100%' }} variant="outlined"
            value={receivedFromName}
            onChange={(e) => setReceivedFromName(e.target.value)}
            inputProps={{ maxLength: 100 }} />
          </Col>
          <Col span={24} md={8} sm={24} xs={24} lg={8} xl={8} xxl={8}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
              <div>
                <DatePicker
                  selected={receivedFromDate}
                  onChange={handleReceivedFromDateChange}
                  dateFormat="dd/MM/yyyy"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  maxDate={today} // Prevent future dates
                  customInput={<StyledTextField variant="outlined" label="Received From Date" />}
                />
              </div>
              <div>


                <DatePicker
                  selected={expectedDeliveryDate}
                  onChange={handleExpectedDeliveryDateChange}
                  dateFormat="dd/MM/yyyy"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  minDate={today} // Prevent past dates
                  customInput={<StyledTextField variant="outlined" label="Expected Delivery Date" />}
                />
              </div>
            </Stack>
          </LocalizationProvider>
          </Col>


        </Row>
        <br></br>
        <Row
          component="form"
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& > :not(style)': { marginRight: '10px' },
          }}
          noValidate
          autoComplete="off"
          gutter={[16, 10]}
        >
          <Col span={24} md={8} sm={24} xs={24} lg={8} xl={8} xxl={8}>
          <TextField
            id="outlined-multiline-static"
            label="Comments"
            sx={{ width: '100%' }} // Add background color here
            multiline
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            inputProps={{ maxLength: 400 }}
          />
          </Col>
          <Col span={24} md={8} sm={24} xs={24} lg={8} xl={8} xxl={8}>
          <label htmlFor="cable-checkbox" style={{ fontWeight: 'bold', textDecoration: 'underline', color: 'blue' }}>Received Items :</label>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <label style={{ marginRight: '10px' }}>
              <input
                type="checkbox"
                checked={motor === 1}
                onChange={handleCheckboxChange(setMotor)}
              />
              Motor
            </label>
            <label style={{ marginRight: '10px' }}>
              <input
                type="checkbox"
                checked={pump === 1}
                onChange={handleCheckboxChange(setPump)}
              />
              Pump
            </label>
            <label style={{ marginRight: '10px' }}>
              <input
                type="checkbox"
                checked={panel === 1}
                onChange={handleCheckboxChange(setPanel)}
              />
              Panel
            </label>
            <label>
              <input
                type="checkbox"
                checked={cable === 1}
                onChange={handleCheckboxChange(setCable)}
              />
              Cable
            </label>
          </div>
          </Col>
        </Row>
        <br></br>

        {/* <Button variant="contained" size='small' style={{ width: isMobile ? '100%' : '30%' , background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)', color: 'black' }} onClick={handleGenerateToken}  >Generate Token Number</Button> */}
        <Button
  variant="contained"
  size="small"
  disabled={generating}
  style={{
    width: isMobile ? '100%' : '30%',
    background: generating
      ? '#ccc'
      : 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
    color: 'black'
  }}
  onClick={handleGenerateToken}
>
  {generating ? 'Generating...' : 'Generate Token Number'}
</Button>

      </Card>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open2} >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
};

export default Defectivegoodsreceipts;
